(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordion = document.querySelector('[data-faq-accordion]');
    if (!accordion) return;

    const buttons = accordion.querySelectorAll('.faq__button');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        const content = button.nextElementSibling;

        buttons.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
          btn.nextElementSibling.style.maxHeight = null;
        });

        if (!isOpen && content) {
          button.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('[data-testimonials-section]');
    if (!section) return;

    const header = section.querySelector('[data-testimonials-header]');
    const grid = section.querySelector('.testimonials__grid');
    if (!header || !grid) return;

    function updateHeader() {
      const sectionTop = section.getBoundingClientRect().top;
      const viewportHeight = window.innerHeight;
      const headerHeight = header.offsetHeight;

      const progress = Math.max(0, Math.min(1, (viewportHeight * 0.6 - sectionTop) / viewportHeight));
      const targetY = (viewportHeight / 2) - (headerHeight / 2) - 160;
      const translateY = progress * Math.max(0, targetY);

      header.style.transform = 'translateY(' + translateY + 'px)';
      header.style.opacity = 1 - progress * 0.1;
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  });

  } catch(e) { console.error(e); }
})();
})();
